module.exports = __webpack_public_path__ + "media/images/sunbasket_july4th/bg-sm-69b754c0f1f416badfd722ba7177c89b.jpg";